import React from 'react';

const TemplateLibrary = ({ color, fill, stroke }) => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_21974_22857)">
          <path
            d="M1.66669 14.9993C1.66669 13.7157 1.66669 13.0738 1.95563 12.6023C2.1173 12.3384 2.33913 12.1166 2.60296 11.9549C3.07447 11.666 3.71632 11.666 5.00002 11.666C6.28372 11.666 6.92557 11.666 7.39708 11.9549C7.66091 12.1166 7.88274 12.3384 8.04441 12.6023C8.33335 13.0738 8.33335 13.7157 8.33335 14.9993C8.33335 16.283 8.33335 16.9249 8.04441 17.3964C7.88274 17.6603 7.66091 17.8821 7.39708 18.0438C6.92557 18.3327 6.28372 18.3327 5.00002 18.3327C3.71632 18.3327 3.07447 18.3327 2.60296 18.0438C2.33913 17.8821 2.1173 17.6603 1.95563 17.3964C1.66669 16.9249 1.66669 16.283 1.66669 14.9993Z"
            stroke={color}
            strokeWidth="1.67"
            fill={fill}
          />
          <path
            d="M11.6667 14.9993C11.6667 13.7157 11.6667 13.0738 11.9556 12.6023C12.1173 12.3384 12.3391 12.1166 12.6029 11.9549C13.0744 11.666 13.7164 11.666 15 11.666C16.2837 11.666 16.9256 11.666 17.3971 11.9549C17.6609 12.1166 17.8828 12.3384 18.0444 12.6023C18.3334 13.0738 18.3334 13.7157 18.3334 14.9993C18.3334 16.283 18.3334 16.9249 18.0444 17.3964C17.8828 17.6603 17.6609 17.8821 17.3971 18.0438C16.9256 18.3327 16.2837 18.3327 15 18.3327C13.7164 18.3327 13.0744 18.3327 12.6029 18.0438C12.3391 17.8821 12.1173 17.6603 11.9556 17.3964C11.6667 16.9249 11.6667 16.283 11.6667 14.9993Z"
            stroke={color}
            strokeWidth="1.67"
            fill={fill}
          />
          <path
            d="M1.66669 4.99935C1.66669 3.71565 1.66669 3.0738 1.95563 2.60229C2.1173 2.33846 2.33913 2.11663 2.60296 1.95496C3.07447 1.66602 3.71632 1.66602 5.00002 1.66602C6.28372 1.66602 6.92557 1.66602 7.39708 1.95496C7.66091 2.11663 7.88274 2.33846 8.04441 2.60229C8.33335 3.0738 8.33335 3.71565 8.33335 4.99935C8.33335 6.28305 8.33335 6.9249 8.04441 7.39641C7.88274 7.66024 7.66091 7.88207 7.39708 8.04374C6.92557 8.33268 6.28372 8.33268 5.00002 8.33268C3.71632 8.33268 3.07447 8.33268 2.60296 8.04374C2.33913 7.88207 2.1173 7.66024 1.95563 7.39641C1.66669 6.9249 1.66669 6.28305 1.66669 4.99935Z"
            stroke={color}
            strokeWidth="1.67"
            fill={fill}
          />
          <path
            d="M11.6667 4.99935C11.6667 3.71565 11.6667 3.0738 11.9556 2.60229C12.1173 2.33846 12.3391 2.11663 12.6029 1.95496C13.0744 1.66602 13.7164 1.66602 15 1.66602C16.2837 1.66602 16.9256 1.66602 17.3971 1.95496C17.6609 2.11663 17.8828 2.33846 18.0444 2.60229C18.3334 3.0738 18.3334 3.71565 18.3334 4.99935C18.3334 6.28305 18.3334 6.9249 18.0444 7.39641C17.8828 7.66024 17.6609 7.88207 17.3971 8.04374C16.9256 8.33268 16.2837 8.33268 15 8.33268C13.7164 8.33268 13.0744 8.33268 12.6029 8.04374C12.3391 7.88207 12.1173 7.66024 11.9556 7.39641C11.6667 6.9249 11.6667 6.28305 11.6667 4.99935Z"
            stroke={color}
            strokeWidth="1.67"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_21974_22857">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default TemplateLibrary;
